import { QueryParamType } from '~/enums/QueryParamType';
import { tryDeserializeJsonObject } from '~/utils/object';

export function getPageSearchQuery() {
  return new URLSearchParams(window.location.search.substring(1));
}

export function getPageSearchQueryByKey<TValue = unknown>(
  key: string | readonly string[],
  defaultValue?: TValue,
) {
  const params = getPageSearchQuery();
  const value = params.get(String(key));
  let valueReturned: unknown = value;
  if (!key) return null as TValue;
  else if (
    key.includes(QueryParamType.ActiveTab) ||
    key.includes(QueryParamType.Page) ||
    key.includes(QueryParamType.PageSize)
  ) {
    valueReturned = !value ? null : Number(value);
  } else if (
    key.includes(QueryParamType.Query) ||
    key.includes(QueryParamType.SelectedItems) ||
    key.includes(QueryParamType.KeywordMatchesQuery)
  ) {
    valueReturned = value === null ? null : tryDeserializeJsonObject(value);
  }
  return (valueReturned ?? defaultValue) as TValue;
}

export function updatePageSearchQuery(
  searchParamsObject: Record<
    string,
    string | number | boolean | null | undefined | object
  >,
  shouldPushHistoryState = false,
) {
  const url = new URL(window.location.href);
  for (const [key, value] of Object.entries(searchParamsObject)) {
    const valueToSet =
      typeof value === 'object' ? JSON.stringify(value) : String(value);
    url.searchParams.set(key, valueToSet);
  }

  if (shouldPushHistoryState) {
    return window.history.pushState({}, '', url);
  }
  return window.history.replaceState({}, '', url);
}

export function deletePageSearchParam(key: string) {
  const url = new URL(window.location.href);
  url.searchParams.delete(key);
  window.history.replaceState({}, '', url);
}
